import React from "react";
import { useLocation } from "wouter";
import useDomain from "../hooks/useDomain";

const MockPage = () => {
  const [location] = useLocation();
  const domain = useDomain();

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>
        {domain} <span className="text-primary">{location}</span>
      </p>
    </div>
  );
};

export default MockPage;
